import { css } from '@emotion/react';

import { CAROUSEL_SIZE_WIDTHS, CAROUSEL_SLIDE_MARGIN } from '@didaskill/domain/html/constants';

import { removeButtonAppearance } from '../../../../../utils/style';

export const container = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${CAROUSEL_SLIDE_MARGIN}px;
  width: 100%;
`;

export const slideNavigationButton = css`
  ${removeButtonAppearance};
  flex-shrink: 0;
  cursor: pointer;
  transition: opacity 0.2s;
`;

export const scrollContainer = (selectedSize: keyof typeof CAROUSEL_SIZE_WIDTHS) => css`
  flex: 1;
  min-width: 0;
  max-width: ${CAROUSEL_SIZE_WIDTHS[selectedSize]}px;
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const slide = css`
  ${removeButtonAppearance};
  flex: 0 0 100%;
  scroll-snap-align: start;
`;

export const imgContainer = css`
  ${removeButtonAppearance};
  display: block;
  width: 100%;
  cursor: zoom-in;
`;

export const image = css`
  width: 100%;
  height: auto;
  display: block;
`;
